import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach access token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401/403 and normalize errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // Network error or timeout
      return Promise.reject({
        message: 'Unable to connect to the server. Please check your internet connection.',
        status: null,
        isNetworkError: true,
      });
    }

    const { status, data } = error.response;

    if (status === 401) {
      const url = error.config?.url || '';
      const isAuthFlowRequest =
        url.includes('/account/login') || url.includes('/forgot-password') || url.includes('/support');
      if (!isAuthFlowRequest) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('admin_user');
        window.location.href = `${process.env.PUBLIC_URL}/login`;
      }
      return Promise.reject({
        message: isAuthFlowRequest
          ? data?.message || 'Invalid email or password.'
          : 'Session expired. Please log in again.',
        status: 401,
      });
    }

    if (status === 403) {
      return Promise.reject({
        message: data?.message || 'You do not have permission to perform this action.',
        status: 403,
      });
    }

    if (status === 422) {
      return Promise.reject({
        message: data?.message || 'Validation error. Please check your input.',
        status: 422,
        errors: data?.errors || null,
      });
    }

    if (status >= 500) {
      return Promise.reject({
        message: 'Something went wrong on the server. Please try again later.',
        status,
      });
    }

    return Promise.reject({
      message: data?.message || 'An unexpected error occurred.',
      status,
      code: data?.code || null,
      data: data?.data ?? null,
    });
  }
);

export default api;
